import React from 'react';

function Scratch(props) {
    return (
        <div>
            Scratch
        </div>
    );
}

export default Scratch;